import { gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import makeOrCacheApiReq from '../../utils/apiCache';

export const getRecommendsRequest = (locale, req) => gwGet(API_PATH.RECOMMENDS_API_PATH, { locale }, req, false);

export const fetchNotice = async (req, locale = 'en') => {
  const queryStr = 'page=1&rows=15';
  const api = API_PATH.GET_NOTICE_API_PATH;
  const cacheGetter = () => gwGet(`${api}?${queryStr}`, { locale }, req);
  const result = await makeOrCacheApiReq(`${api}${locale}`, cacheGetter, res => res.success && Array.isArray(res.data));
  return result.data || [];
};

export default {};
